import { Module } from 'vuex'

type NameplateReissueStateType = {
  cacheRouteNames: Array<string>
}

export const NameplateReissueList = 'nameplate-reissue-list'
export const NameplateReissueApply = 'nameplate-reissue-apply'
export const NameplateReissueDetail = 'nameplate-reissue-detail'

const nameplateReissue: Module<NameplateReissueStateType, any> = {
  namespaced: true,
  state: {
    cacheRouteNames: [NameplateReissueList, NameplateReissueApply, NameplateReissueDetail],
  },
  mutations: {
    addCacheRouteName(state, cacheRouteName) {
      console.log(
        'addCacheRouteName',
        state.cacheRouteNames.find((_) => _ === cacheRouteName)
      )
      if (state.cacheRouteNames.find((_) => _ === cacheRouteName)) {
        return
      } else {
        state.cacheRouteNames.push(cacheRouteName)
      }
    },
    removeCacheRouteName(state, cacheRouteName) {
      console.log(
        'removeCacheRouteName',
        state.cacheRouteNames.filter((_) => _ !== cacheRouteName)
      )
      state.cacheRouteNames = state.cacheRouteNames.filter((_) => _ !== cacheRouteName)
    },
  },
  actions: {},
}

export default nameplateReissue
